import { Observable, of, mergeMap, filter } from 'rxjs'
import { ofEntityUpdateType } from './epicUtils'
import { GridId } from 'store/grid'
import { SelectionActions } from 'store/selection'
import { BTQAction } from 'epics'
import { EntityType, AxeSubscriptionIdentifier, AxeStatus } from 'api'

export function axeEventReceivedEpic(action$: Observable<BTQAction>): Observable<BTQAction> {
  return action$.pipe(
    ofEntityUpdateType(EntityType.AXE),
    filter(action => action.axeStatus !== AxeStatus.CANCELLED),
    mergeMap(action => {
      const actions = [
        ...(action.subscriptionIdentifiers.includes(AxeSubscriptionIdentifier.AXE_TODAY_INITIATOR)
          ? [SelectionActions.setGridActivityHighlight(GridId.AxeGridInitiator, true)]
          : []),
        ...(action.subscriptionIdentifiers.includes(AxeSubscriptionIdentifier.AXE_TODAY_RESPONDER)
          ? [SelectionActions.setGridActivityHighlight(GridId.AxeGridResponder, true)]
          : [])
      ]

      return of(...actions)
    })
  )
}
